module.exports = __webpack_public_path__ + "static/media/down-w.e870ca97.svg";